import React from 'react';
import { createRoot } from 'react-dom/client';
import 'src/common/sentry/sentry';
import App from './app';

const container = document.getElementById('content');

if (!container) {
  throw new Error('Failed to find root element');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
